import { useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Tooltip from "react-tooltip-lite";
import moment from "moment";
import PerfectScrollbar from "react-perfect-scrollbar";

import { ChevronLeft, ChevronRight } from "react-feather";
import { updateAskVyrillState } from "../Actions";
import {
  CREATE_CONVERSATION_MUTATION,
  GET_MESSAGES_QUERY,
  UPDATE_CONVERSATION_MUTATION,
} from "../../../Queries/ask-vyrill";
import { HistoryIcon } from "../../../Shared/SVGs/HistoryIcon";
import HistoryAction from "./HistoryAction";
import Loading from "../../../Shared/Loading";

function TimeAgo({ datetime }) {
  const formattedDate = moment(datetime).fromNow();
  return <div className="history-day">{formattedDate}</div>;
}

const ModalChatHistory = ({}) => {
  const [isEdit, setIsEdit] = useState({
    id: "",
    value: "",
  });
  const allConversations = useSelector(
    (state) => state.askVyrill?.allConversations
  );

  const historyLoading = useSelector(
    (state) => state.askVyrill?.historyLoading
  );

  const conversationId = useSelector(
    (state) => state.askVyrill?.conversationId
  );
  const currentBrandId = useSelector(
    (state) => state.selectedBrandReducer?.brand_id
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [createConversation, { data, loading: newConversationLoading, error }] =
    useMutation(CREATE_CONVERSATION_MUTATION);
  const {
    loading,
    error: messagesError,
    data: messagesData,
    refetch: refetchMessages,
  } = useQuery(GET_MESSAGES_QUERY, {
    skip: true,
  });

  const handleConversation = (id) => {
    dispatch(
      updateAskVyrillState({
        messages: [],
        conversationId: id,
        askVyrillError: false,
        askVyrillTimoutError: false,
        loadFromHistory: true,
      })
    );
    navigate(`/ask_vyrill`);

    refetchMessages({
      conversationId: id,
    }).then((res) => {
      const sortedData = (res?.data?.getMessages || []).slice().reverse();
      dispatch(
        updateAskVyrillState({
          messages: sortedData,
        })
      );
    });

    // dispatch(
    //   updateAskVyrillState({
    //     messages: [],
    //     messagesLoading: true,
    //     conversationId: id,
    //     loadFromHistory: true,
    //   })
    // );
  };

  // const handleNewConversation = async () => {
  //   // Clear existing messages
  //   dispatch(
  //     updateAskVyrillState({
  //       messages: [],
  //       conversationId: "",
  //       selectedPrompt: "",
  //       isNewChat: true,
  //       askVyrillError: false,
  //       askVyrillTimoutError: false,
  //       // allConversations: [newChat, ...allConversations],
  //     })
  //   );

  //   try {
  //     const { data } = await createConversation({
  //       variables: { brandId: currentBrandId },
  //     });
  //     if (data.createConversation) {
  //       dispatch(
  //         updateAskVyrillState({
  //           conversationId: data.createConversation._id,
  //         })
  //       );
  //     }
  //   } catch (err) {
  //     // Handle errors
  //     console.error(err);
  //   }
  // };

  const [updateTitle, { data: updateConversation }] = useMutation(
    UPDATE_CONVERSATION_MUTATION,
    {
      variables: {
        conversationId: isEdit.id,
        title: isEdit.value,
      },
      onCompleted: ({ updateConversation }) => {
        const updatedArray = allConversations.map((obj) => {
          if (obj?._id === updateConversation?._id) {
            return updateConversation; // Replaced with the new object
          } else {
            return obj; // Keep the original object
          }
        });

        dispatch(
          updateAskVyrillState({
            allConversations: updatedArray,
          })
        );
        setIsEdit({ id: "", value: "" });
      },
      onError: (error) => {
        console.error("Mutation error:", error);
      },
    }
  );

  const handleEdit = () => {
    updateTitle();
  };

  return (
    <div className="modal-card-history">
      <div className="history-top">
        <div className="history-label">
          <HistoryIcon />
          History
        </div>
      </div>
      {historyLoading ? (
        <Loading className='d-card-loading d-flex justify-content-center'/>
      ) : (
        <PerfectScrollbar
          className="main-menu-content pe-1 modal-all-converstations"
          options={{ wheelPropagation: true, maxScrollbarLength: 70 }}
          style={{ maxHeight: "380px", overflow: "auto" }}
        >
          {allConversations?.map((k, index) => {
            return (
              <div key={index} className="conversation-item">
                <div className="c-header">
                  <TimeAgo datetime={k.updated_at} />
                </div>

                <div className="c-title-section">
                  {isEdit.id === k._id ? (
                    <input
                      type="text"
                      className="item-update-input"
                      value={isEdit.value}
                      onChange={(e) => {
                        setIsEdit({ ...isEdit, value: e.target.value });
                      }}
                    />
                  ) : (
                    <Tooltip
                      content={
                        <div
                          style={{ textAlign: "center", cursor: "pointer" }}
                          onClick={() => handleConversation(k._id)}
                        >
                          <span className="tooltip-date">
                            <TimeAgo datetime={k.updated_at} />
                          </span>
                          {k.title}
                        </div>
                      }
                      id={index}
                      direction="left"
                      className="customTip"
                    >
                      <div
                        className={`c-label ${
                          conversationId == k._id && "active-conversation"
                        }`}
                        onClick={() => handleConversation(k._id)}
                      >
                        {k.title}
                      </div>
                    </Tooltip>
                  )}

                  <HistoryAction
                    setIsEdit={setIsEdit}
                    id={k._id}
                    value={k.title}
                    isEdit={isEdit}
                    handleEdit={handleEdit}
                  />
                </div>
              </div>
            );
          })}
        </PerfectScrollbar>
      )}
    </div>
  );
};

export default ModalChatHistory;
